import { useEffect, useState } from 'react';

import {
  StyledCarouselCards,
  StyledCarouselContainer,
  StyledCarouselStepIndicator,
  StyledCarouselStepIndicatorContainer,
  StyledCarouselWrapper,
} from '@webclient/components/user-authentication/components/carousel/styles';

type Props = {
  cards: React.ReactElement[];
  step?: number;
};

export default function Carousel({ cards, step }: Props) {
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedCardIndex((prevIndex) =>
        prevIndex === cards.length - 1 ? 0 : prevIndex + 1,
      );
    }, step || 6000);

    return () => clearInterval(interval);
  }, [step, cards.length]);

  return (
    <StyledCarouselWrapper>
      <StyledCarouselContainer>
        <StyledCarouselCards selectedIndex={selectedCardIndex}>
          {cards}
        </StyledCarouselCards>

        <StyledCarouselStepIndicatorContainer>
          {cards.map((card, index) => (
            <StyledCarouselStepIndicator
              key={`indicator-${index}`}
              isSelected={selectedCardIndex === index}
            />
          ))}
        </StyledCarouselStepIndicatorContainer>
      </StyledCarouselContainer>
    </StyledCarouselWrapper>
  );
}
